/**
 * OutlinedInput Component
 *
 * Abstraction layer over MUI OutlinedInput.
 * Used with InputLabel and FormControl for custom form layouts.
 */

import { OutlinedInput as MuiOutlinedInput, OutlinedInputProps } from '@mui/material';
import React from 'react';

const OutlinedInput = React.forwardRef<HTMLDivElement, OutlinedInputProps>((props, ref) => {
  return <MuiOutlinedInput ref={ref} {...props} />;
});

OutlinedInput.displayName = 'OutlinedInput';

export default OutlinedInput;
